import { transferFromGalleryToProduct } from '@/lib/api/product-images'
import { materializeRemakeGeneration } from '@/lib/api/amazon-listing'
import type { AddToProductImage } from '../types'

/**
 * Resolves the source image to an assets.id ready for linkAssetToChannel.
 *
 * - kind==='remake': calls the materialize-asset endpoint (returns a real asset_id).
 * - all other kinds: calls transferFromGalleryToProduct (collection path).
 *
 * Returns null on any failure so callers can count it as an error without throwing.
 */
export async function ensureAssetId(
  image: AddToProductImage,
  productId: string,
): Promise<string | null> {
  if (image.kind === 'remake' && image.remakeId && image.generationId) {
    try {
      const r = await materializeRemakeGeneration(image.remakeId, image.generationId)
      return r?.asset_id ?? null
    } catch {
      return null
    }
  }
  const t = await transferFromGalleryToProduct(image.id, productId, { targetType: 'collection' })
  return t?.success ? (t.asset_id ?? null) : null
}
